module.exports = __webpack_public_path__ + "img/horizontal_4_5_8019.9da5f774.png";